<template>
  <!-- eslint-disable -->
  <div :class="{ dropdown: !isOpen, 'dropdown open': isOpen }">
    <button
      aria-label="News Category"
      type="button"
      aria-haspopup="listbox"
      @click="handleClickDropdown"
    >
      <div class="dropdown-option--pseudo" :data-value="defaultSelection.value">{{ defaultSelection.text }}</div>
    </button>
    <ul class="dropdown-listbox" role="listbox" tabindex="-1">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    }
  },
  props: {
    defaultSelection: {
      type: Object,
      default: function() {
        return {
          value: '',
          text: '',
        }
      },
    },
  },
  mounted() {
    this.optionIndex = -1
    // all children of <ul> element
    this.options = Array.from(this.$el.children[1].children)
    // initialize selection displayed in button
    // update div inside button to display selected value
    var option = this.options[0]
    if (this.defaultSelection.value == '' && this.defaultSelection.text == '') {
      this.$el.children[0].children[0].textContent = option.textContent
      this.$el.children[0].children[0].dataset.value = option.dataset.value
    }
    var that = this
    this.options.forEach(function(option) {
      option.setAttribute('aria-selected', false)
      if (option.dataset.value == that.defaultSelection.value) {
        option.setAttribute('aria-selected', true)
      }
      option.addEventListener('click', function() {
        that.updateSelection(option)
        that.closeDropdown()
      })
    })
  },
  methods: {
    handleClickDropdown() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.openDropdown()
      } else {
        this.closeDropdown()
      }
    },

    handleKey(e) {
      // up and down arrows to navigate dropdown
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        if (this.optionIndex < this.options.length - 1) {
          this.setHovering(this.optionIndex + 1)
        }
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault()
        if (this.optionIndex > 0) {
          this.setHovering(this.optionIndex - 1)
        }
      }

      // enter or space to select
      if (e.key === 'Enter' || e.keyCode === 32) {
        e.preventDefault()
        if (this.optionIndex > -1) {
          this.updateSelection(this.options[this.optionIndex])
        }
        this.closeDropdown()
      }

      if (e.key === 'Escape') {
        this.closeDropdown()
      }

      // prevent navigating away
      if (e.key === 'Tab') {
        e.preventDefault()
      }
    },

    openDropdown() {
      document.addEventListener('click', this.checkClickedOutside)
      document.addEventListener('keydown', this.handleKey)
      this.isOpen = true
    },

    closeDropdown() {
      document.removeEventListener('click', this.checkClickedOutside)
      document.removeEventListener('keydown', this.handleKey)
      if (this.optionIndex > -1) {
        this.options[this.optionIndex].classList.remove('hovering')
      }
      this.optionIndex = -1
      this.isOpen = false
    },

    checkClickedOutside(e) {
      // if clicked outside dropdown, close it
      if (!this.$el.contains(e.target)) {
        this.closeDropdown()
      }
    },

    updateSelection(option) {
      // update div inside button to display selected value
      this.$el.children[0].children[0].textContent = option.textContent
      this.$el.children[0].children[0].dataset.value = option.dataset.value
      this.$emit('changed', option.dataset.value)
    },

    setHovering(index) {
      // add hover effect to options when navigating using keyboard
      var prevOption = this.options[this.optionIndex]
      var option = this.options[index]

      if (prevOption) {
        prevOption.classList.remove('hovering')
        prevOption.setAttribute('aria-selected', false)
      }
      if (option) {
        option.classList.add('hovering')
        option.setAttribute('aria-selected', true)
        option.focus()
      }

      this.optionIndex = index
    },
  },
}
</script>
